import { Typography, Grid } from '@mui/material';
import { OrderDto, formatUserNameOrId } from 'desk-common';

interface OrderSummaryInfoProps {
  order: OrderDto;
}

export const OrderSummaryInfo = ({ order }: OrderSummaryInfoProps) => {
  return (
    <>
      <Typography variant="subtitle1" fontWeight={700} mb={3}>
        Información General
      </Typography>

      <Grid container spacing={3} mb={5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Usuario
          </Typography>
          <Typography fontWeight={600}>
            {formatUserNameOrId(order.userCreated, order.userCreatedId)}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Centro de costos
          </Typography>
          <Typography fontWeight={600}>{order.costCenter?.name}</Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Aprobador centro de costos
          </Typography>
          <Typography fontWeight={600}>
            {formatUserNameOrId(
              order.costCenterApprover,
              order.costCenterApproverId ?? order.costCenter?.approverId
            )}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Fecha de aprobación por centro de costo
          </Typography>
          <Typography fontWeight={600}>
            {order.costCenterApprovedAt
              ? new Date(order.costCenterApprovedAt).toLocaleDateString()
              : '-'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Aprobador área compras
          </Typography>
          <Typography fontWeight={600}>
            {formatUserNameOrId(
              order.purchaseApprover,
              order.purchaseApproverId
            )}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Fecha de aprobación área compras
          </Typography>
          <Typography fontWeight={600}>
            {order.purchaseApprovedAt
              ? new Date(order.purchaseApprovedAt).toLocaleDateString()
              : '-'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="caption" color="text.secondary">
            Fecha de creación
          </Typography>
          <Typography fontWeight={600}>
            {new Date(order.createdAt).toLocaleDateString()}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
